/**
 * Noellume landing page behaviour (sections/mg-landing.liquid)
 *  - midnight countdown timers ([data-mg-midnight-timer])
 *  - scroll reveal, sticky buy bar, "scroll to buy" buttons
 *  - media gallery (swipe / thumbs / arrows / keyboard)
 *  - bundle selector ([data-mg-bundles] .mgb__bar[data-variant]) + gift / shipping-protection add-ons
 *  - add to cart: POST /cart/add with the selected bundle variant, gift and protection attached
 *    as extra items (ids come from [data-addon] attributes)
 */
(function () {
  'use strict';

  if (window.__mgLpLoaded) return;
  window.__mgLpLoaded = true;

  /** Moderation theme: no urgency timers / ratings / shipping protection. */
  function mgIsModeration() {
    return !!document.querySelector('[data-mg-moderation], .mg-lp--moderation');
  }

  /* ---------------------------------------------------------------------- *
   * Midnight countdown
   * ---------------------------------------------------------------------- */
  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function tickTimers() {
    var now = new Date();
    var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
    var diff = Math.max(0, Math.floor((midnight - now) / 1000));
    var h = pad(Math.floor(diff / 3600));
    var m = pad(Math.floor((diff % 3600) / 60));
    var s = pad(diff % 60);

    document.querySelectorAll('[data-mg-midnight-timer]').forEach(function (el) {
      var eh = el.querySelector('[data-h]');
      var em = el.querySelector('[data-m]');
      var es = el.querySelector('[data-s]');
      if (eh) eh.textContent = h;
      if (em) em.textContent = m;
      if (es) es.textContent = s;
    });
  }

  tickTimers();
  setInterval(tickTimers, 1000);

  /* ---------------------------------------------------------------------- *
   * Add-to-cart fetch interceptor (gift + shipping protection)
   * ---------------------------------------------------------------------- */
  var bundleRoots = [];

  function bundleRootForVariant(id) {
    id = String(id);
    for (var i = 0; i < bundleRoots.length; i++) {
      if (bundleRoots[i].el.isConnected && bundleRoots[i].variantIds[id]) return bundleRoots[i];
    }
    return null;
  }

  var nativeFetch = window.fetch;

  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, opts) {
      try {
        var url = String((input && input.url) || input);

        if (/\/cart\/add/.test(url) && opts && typeof FormData !== 'undefined' && opts.body instanceof FormData) {
          var fd = opts.body;
          var hasItems = Array.from(fd.keys()).some(function (k) {
            return /^items\[\d+\]\[id\]$/.test(k);
          });
          var mainId = hasItems ? fd.get('items[0][id]') : fd.get('id');
          var api = mainId ? bundleRootForVariant(mainId) : null;

          if (api) {
            if (!hasItems && fd.get('id')) {
              // Single-item request: convert to the items[] form so add-ons can ride along.
              var qty = fd.get('quantity') || '1';
              fd.delete('id');
              fd.delete('quantity');
              fd.append('items[0][id]', mainId);
              fd.append('items[0][quantity]', qty);
            }

            var present = {};
            var next = 0;
            fd.forEach(function (val, key) {
              var m = key.match(/^items\[(\d+)\]\[id\]$/);
              if (m) {
                next = Math.max(next, +m[1] + 1);
                present[String(val)] = true;
              }
            });

            api.wantedAddons().forEach(function (addonId) {
              if (present[addonId]) return;
              fd.append('items[' + next + '][id]', addonId);
              fd.append('items[' + next + '][quantity]', '1');
              next++;
            });
          }
        }
      } catch (err) {
        /* never block the request */
      }

      return nativeFetch.apply(this, arguments);
    };
  }

  /* ---------------------------------------------------------------------- *
   * Bundle selector + ATC
   * ---------------------------------------------------------------------- */
  function initBundles(root) {
    if (root.__mgInit) return;
    root.__mgInit = true;

    var form = root.closest('form');
    var bars = Array.prototype.slice.call(root.querySelectorAll('.mgb__bar'));
    var giftLine = root.querySelector('[data-gift-line]');
    var giftId = giftLine ? (giftLine.getAttribute('data-addon') || '').trim() : '';
    var giftToggle = root.querySelector('[data-gift-toggle]');
    var protectRow = root.querySelector('.mgb__protect');
    var protectId = protectRow ? (protectRow.getAttribute('data-addon') || '').trim() : '';
    var protectToggle = root.querySelector('[data-protect-toggle]');

    var idInput = form ? form.querySelector('[data-mg-id]') : null;
    var qtyInput = form ? form.querySelector('[data-mg-qty]') : null;
    var submitBtn = form ? form.querySelector('[data-mg-atc]') : null;
    var errorBox = form ? form.querySelector('[data-mg-error]') : null;

    function selectedBar() {
      return root.querySelector('.mgb__bar.is-selected') || bars[0];
    }

    function giftWanted() {
      var bar = selectedBar();
      return !!((bar && bar.getAttribute('data-gift') === 'true') || (giftToggle && giftToggle.checked));
    }

    function protectWanted() {
      if (mgIsModeration()) return false;
      // No LP checkbox → default ON (cart drawer upsell). Checkbox present → follow it.
      if (!protectToggle) return true;
      return !!protectToggle.checked;
    }

    function wantedAddons() {
      var list = [];
      if (giftId && giftWanted()) list.push(giftId);
      var pid = protectId || mgProtectId();
      if (pid && protectWanted()) list.push(pid);
      return list;
    }

    function applyTier() {
      var bar = selectedBar();
      if (!bar) return;
      root.setAttribute('data-gift', bar.getAttribute('data-gift') === 'true' ? 'true' : 'false');
      if (idInput) {
        idInput.value = bar.getAttribute('data-variant') || idInput.value;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (qtyInput) qtyInput.value = bar.getAttribute('data-qty') || '1';
    }

    function select(bar) {
      bars.forEach(function (b) {
        var on = b === bar;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      applyTier();
    }

    // Register for the fetch interceptor
    var variantIds = {};
    bars.forEach(function (b) {
      var v = b.getAttribute('data-variant');
      if (v) variantIds[String(v)] = true;
    });
    if (idInput && idInput.value) variantIds[String(idInput.value)] = true;
    bundleRoots.push({ el: root, variantIds: variantIds, wantedAddons: wantedAddons });

    root.addEventListener('click', function (e) {
      if (e.target.closest('input[type="checkbox"], label')) return;
      var b = e.target.closest('.mgb__bar');
      if (b) select(b);
    });

    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var b = e.target.closest('.mgb__bar');
      if (!b) return;
      e.preventDefault();
      select(b);
    });

    applyTier();

    if (!form) return;

    function showError(msg) {
      if (!errorBox) return;
      errorBox.textContent = msg || '';
      errorBox.hidden = !msg;
    }

    function setLoading(on) {
      if (!submitBtn) return;
      var label = submitBtn.querySelector('[data-mg-atc-label]');
      submitBtn.disabled = on;
      submitBtn.classList.toggle('is-loading', on);
      if (label) {
        if (on) {
          label.setAttribute('data-original', label.textContent);
          label.textContent = submitBtn.getAttribute('data-loading-text') || 'Adding…';
        } else if (label.getAttribute('data-original')) {
          label.textContent = label.getAttribute('data-original');
        }
      }
    }

    var busy = false;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      if (!idInput || !idInput.value) {
        showError('Please choose a product for this section.');
        return;
      }

      applyTier();
      showError('');
      busy = true;
      setLoading(true);

      var addUrl = form.getAttribute('data-cart-add-url') || '/cart/add.js';
      var redirect = (form.getAttribute('data-redirect') || '').trim();
      var body = new FormData(form);
      // Ask Shopify to return the cart-drawer section HTML (Horizon Section Rendering).
      if (!body.get('sections')) {
        body.append('sections', 'cart-drawer-section');
        body.append('sections_url', window.location.pathname);
      }

      // The fetch interceptor above turns this into items[] and attaches any remaining add-ons.
      window
        .fetch(addUrl, {
          method: 'POST',
          body: body,
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        })
        .then(function (res) {
          return res.json().then(function (json) {
            return { ok: res.ok, json: json };
          });
        })
        .then(function (r) {
          if (!r.ok || (r.json && r.json.status)) {
            throw new Error((r.json && (r.json.description || r.json.message)) || 'Could not add to cart.');
          }
          document.dispatchEvent(new CustomEvent('mg:cart-added', { detail: r.json }));
          if (redirect) {
            window.location.href = redirect;
            return;
          }
          return mgCartRefreshAndOpen().finally(function () {
            busy = false;
            setLoading(false);
          });
        })
        .catch(function (err) {
          showError(err && err.message ? err.message : 'Could not add to cart.');
          busy = false;
          setLoading(false);
        });
    });
  }

  /* ---------------------------------------------------------------------- *
   * Donor-style cart drawer (data-mg-cd)
   * ---------------------------------------------------------------------- */
  var MG_CART_TIMER_KEY = 'mg_cart_reserve_ends';
  var mgCartState = {
    cart: null,
    timerEnds: 0,
    timerInterval: 0,
    protectOptedOut: false,
    protectBusy: false
  };

  function mgMoney(cents) {
    cents = Number(cents) || 0;
    var root = document.querySelector('[data-mg-cd]');
    var format = (root && root.getAttribute('data-money-format')) || '${{amount}}';
    var amount = (Math.abs(cents) / 100).toFixed(2);
    var amountWithComma = amount.replace('.', ',');
    var amountNoDecimals = String(Math.round(Math.abs(cents) / 100));
    var out;
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try { out = Shopify.formatMoney(Math.abs(cents), format); } catch (e) { out = null; }
    }
    if (!out) {
      out = format
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithComma)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
        .replace(/\{\{\s*amount\s*\}\}/g, amount)
        .replace(/\{\{\s*amount_with_currency\s*\}\}/g, amount);
    }
    return cents < 0 ? '-' + out : out;
  }

  function mgCompareMap() {
    var root = document.querySelector('[data-mg-cd]');
    if (!root) return {};
    try {
      return JSON.parse(root.getAttribute('data-compare-map') || '{}') || {};
    } catch (e) {
      return {};
    }
  }

  /** Bundle/compare-at savings (donor-style Savings row). cart.js omits compare_at — use liquid map. */
  function mgCartSavingsCents(cart, protectId) {
    var map = mgCompareMap();
    var savings = 0;
    (cart.items || []).forEach(function (it) {
      if (String(it.id) === protectId || String(it.variant_id) === protectId) return;
      var qty = Number(it.quantity) || 0;
      var final = Number(it.final_line_price != null ? it.final_line_price : it.line_price) || 0;
      var vid = String(it.variant_id || it.id);
      var cmp = Number(it.compare_at_price) || Number(map[vid]) || 0;
      if (cmp > 0) {
        savings += Math.max(0, cmp * qty - final);
        return;
      }
      var orig = Number(it.original_line_price) || 0;
      savings += Math.max(0, orig - final);
    });
    if (savings <= 0) savings = Number(cart.total_discount) || 0;
    return savings;
  }

  function mgBrandTitle(str) {
    return String(str || '')
      .replace(/MerryGlow™️/gi, 'Noellume™️')
      .replace(/MerryGlow™/gi, 'Noellume™')
      .replace(/MerryGlow/gi, 'Noellume');
  }

  function mgVariantLabel(item) {
    var t = (item.variant_title || '').trim();
    var qty = Number(item.quantity) || 0;
    if (!t || t === 'Default Title' || /^buy\s*1$/i.test(t)) {
      if (qty <= 1) return '1 Projector';
      return qty + ' Projectors';
    }
    if (/^buy\s*2$/i.test(t)) return '2 Projectors';
    if (/^buy\s*3$/i.test(t)) {
      return qty > 0 ? qty + (qty === 1 ? ' Projector' : ' Projectors') : '3 Projectors';
    }
    return t;
  }

  /**
   * Single SKU mode: one projector variant, cart qty = projector count.
   * Legacy pack variant ids (Buy 2 / Buy 3) are remapped to Buy 1 qty if still present.
   */
  var MG_LEGACY_PACK_UNITS = {
    '59521235616092': 2,
    '59521235648860': 1
  };

  function mgBundleMap() {
    var root = document.querySelector('[data-mg-cd]');
    if (!root) return null;
    try {
      return JSON.parse(root.getAttribute('data-bundle-map') || 'null');
    } catch (e) {
      return null;
    }
  }

  function mgPrimaryVariantId(map) {
    map = map || mgBundleMap();
    if (!map || !map.buy1 || !map.buy1.id) return '';
    return String(map.buy1.id);
  }

  function mgBundleIds(map) {
    map = map || mgBundleMap();
    var out = {};
    var primary = mgPrimaryVariantId(map);
    if (primary) out[primary] = { key: 'buy1', units: 1 };
    Object.keys(MG_LEGACY_PACK_UNITS).forEach(function (id) {
      out[id] = { key: 'legacy-' + id, units: MG_LEGACY_PACK_UNITS[id] };
    });
    return out;
  }

  function mgIsBundleLine(it, ids) {
    ids = ids || mgBundleIds();
    return !!(ids[String(it.variant_id || it.id)]);
  }

  function mgProjectorCount(cart, protectId) {
    var ids = mgBundleIds();
    var n = 0;
    mgCartProductItems(cart, protectId).forEach(function (it) {
      var meta = ids[String(it.variant_id || it.id)];
      if (!meta) return;
      n += meta.units * (Number(it.quantity) || 0);
    });
    return n;
  }

  function mgDesiredBundleLine(n, map) {
    map = map || mgBundleMap();
    var primary = mgPrimaryVariantId(map);
    if (!primary || n <= 0) return null;
    return { id: Number(primary), qty: n };
  }

  /**
   * Ensure projector lines are a single primary variant with qty = projector count.
   * Converts any leftover Buy 2 / Buy 3 pack lines after the single-SKU migration.
   */
  function mgCartNormalizeBundles(cart) {
    var map = mgBundleMap();
    var ids = mgBundleIds(map);
    var primary = mgPrimaryVariantId(map);
    if (!primary || !Object.keys(ids).length) return Promise.resolve(cart);

    var protectId = mgProtectId();
    var bundleLines = mgCartProductItems(cart, protectId).filter(function (it) {
      return mgIsBundleLine(it, ids);
    });
    if (!bundleLines.length) return Promise.resolve(cart);

    var n = mgProjectorCount(cart, protectId);
    var desired = mgDesiredBundleLine(n, map);
    if (!desired) return Promise.resolve(cart);

    var already =
      bundleLines.length === 1 &&
      Number(bundleLines[0].variant_id || bundleLines[0].id) === desired.id &&
      Number(bundleLines[0].quantity) === desired.qty;
    if (already) return Promise.resolve(cart);

    var updates = {};
    bundleLines.forEach(function (it) {
      updates[it.key] = 0;
    });

    return nativeFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { return r.json(); })
      .then(function (cleared) {
        if (cleared.status) throw new Error(cleared.description || cleared.message || 'Cart update failed');
        if (desired.qty < 1) {
          mgCartRender(cleared);
          return cleared;
        }
        return nativeFetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: desired.id, quantity: desired.qty }] })
        })
          .then(function (r) { return r.json(); })
          .then(function (added) {
            if (added.status) throw new Error(added.description || added.message || 'Cart add failed');
            return nativeFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
              return r.json();
            });
          })
          .then(function (next) {
            mgCartRender(next);
            return next;
          });
      });
  }

  function mgProtectId() {
    var root = document.querySelector('[data-mg-cd]');
    return root ? String(root.getAttribute('data-protect-id') || '').trim() : '';
  }

  function setCartCount(n) {
    n = Number(n) || 0;
    document.querySelectorAll('[data-mg-cart-count]').forEach(function (el) {
      el.textContent = String(n);
      el.classList.toggle('is-empty', n < 1);
    });
  }

  function mgCartIsPageMode(root) {
    root = root || document.querySelector('[data-mg-cd]');
    return !!(root && root.classList.contains('mg-cd--page'));
  }

  function mgCartOpen() {
    var root = document.querySelector('[data-mg-cd]');
    if (!root) return;
    if (mgCartIsPageMode(root)) {
      root.hidden = false;
      root.classList.add('is-open');
      mgCartStartTimer(root);
      return;
    }
    root.hidden = false;
    requestAnimationFrame(function () {
      root.classList.add('is-open');
      mgCartStartTimer(root);
    });
    document.body.classList.add('mg-cd-open');
  }

  function mgCartClose() {
    var root = document.querySelector('[data-mg-cd]');
    if (!root || mgCartIsPageMode(root)) return;
    root.classList.remove('is-open');
    document.body.classList.remove('mg-cd-open');
    setTimeout(function () {
      if (!root.classList.contains('is-open')) root.hidden = true;
    }, 320);
  }

  function mgCartPad2(n) {
    n = Math.max(0, Number(n) || 0);
    return (n < 10 ? '0' : '') + n;
  }

  function mgCartPaintTimer(root) {
    var clock = root.querySelector('[data-mg-cd-timer-clock]');
    if (!clock) return 0;
    var left = Math.max(0, Math.floor((mgCartState.timerEnds - Date.now()) / 1000));
    var durationEl = root.querySelector('[data-mg-cd-timer]');
    var full = parseInt((durationEl && durationEl.getAttribute('data-duration')) || '300', 10) || 300;
    // Donor countdown-timer: when duration hits 0, reset (keeps urgency bar alive).
    if (left <= 0) {
      mgCartState.timerEnds = Date.now() + full * 1000;
      try { sessionStorage.setItem(MG_CART_TIMER_KEY, String(mgCartState.timerEnds)); } catch (e) {}
      left = full;
    }
    var m = Math.floor(left / 60);
    var s = left % 60;
    clock.textContent = mgCartPad2(m) + ':' + mgCartPad2(s);
    return left;
  }

  function mgCartStartTimer(root) {
    if (!root) return;
    var durationEl = root.querySelector('[data-mg-cd-timer]');
    var clock = root.querySelector('[data-mg-cd-timer-clock]');
    if (!clock) return;
    var full = parseInt((durationEl && durationEl.getAttribute('data-duration')) || '300', 10) || 300;

    var stored = 0;
    try { stored = parseInt(sessionStorage.getItem(MG_CART_TIMER_KEY) || '0', 10) || 0; } catch (e) {}
    if (stored > Date.now()) {
      mgCartState.timerEnds = stored;
    } else if (!mgCartState.timerEnds || mgCartState.timerEnds < Date.now()) {
      mgCartState.timerEnds = Date.now() + full * 1000;
      try { sessionStorage.setItem(MG_CART_TIMER_KEY, String(mgCartState.timerEnds)); } catch (e) {}
    }

    mgCartPaintTimer(root);
    if (mgCartState.timerInterval) clearInterval(mgCartState.timerInterval);
    // Same cadence as donor <countdown-timer>: setInterval 1000ms
    mgCartState.timerInterval = setInterval(function () {
      if (!document.querySelector('[data-mg-cd].is-open')) return;
      mgCartPaintTimer(root);
    }, 1000);
  }

  function mgCartIsProtect(it, protectId) {
    protectId = protectId || mgProtectId();
    return String(it.id) === protectId || String(it.variant_id) === protectId;
  }

  function mgCartProductItems(cart, protectId) {
    protectId = protectId || mgProtectId();
    return (cart && cart.items || []).filter(function (it) {
      return !mgCartIsProtect(it, protectId);
    });
  }

  function mgCartProtectLine(cart, protectId) {
    protectId = protectId || mgProtectId();
    return (cart && cart.items || []).find(function (it) {
      return mgCartIsProtect(it, protectId);
    }) || null;
  }

  function mgCartProtectCents(cart) {
    var line = mgCartProtectLine(cart);
    if (line) return Number(line.final_line_price != null ? line.final_line_price : line.line_price) || 0;
    var root = document.querySelector('[data-mg-cd]');
    var raw = (root && root.getAttribute('data-protect-price')) || '';
    var n = parseFloat(String(raw).replace(/[^0-9.,]/g, '').replace(',', '.'));
    return isFinite(n) ? Math.round(n * 100) : 489;
  }

  function mgCartPaintProtectUI(selected) {
    var root = document.querySelector('[data-mg-cd]');
    if (!root) return;
    var upsell = root.querySelector('[data-mg-cd-upsell]');
    if (!upsell) return;
    upsell.setAttribute('data-selected', selected ? 'true' : 'false');
    var tog = upsell.querySelector('[data-mg-cd-upsell-toggle]');
    if (tog) tog.setAttribute('aria-pressed', selected ? 'true' : 'false');
  }

  function mgCartRender(cart) {
    mgCartState.cart = cart;
    var root = document.querySelector('[data-mg-cd]');
    if (!root || !cart) return;
    var protectId = mgProtectId();
    var items = mgCartProductItems(cart, protectId);
    var protectInCart = !!mgCartProtectLine(cart, protectId);
    // Header / badge = projector count (Buy 2 pack counts as 2)
    var headerCount = mgProjectorCount(cart, protectId);
    if (!headerCount) {
      headerCount = items.reduce(function (n, it) { return n + (it.quantity || 0); }, 0);
    }
    setCartCount(headerCount);

    var title = root.querySelector('[data-mg-cd-title]');
    if (title) {
      title.textContent = 'Cart • ' + headerCount + (headerCount === 1 ? ' item' : ' items');
    }

    var empty = root.querySelector('[data-mg-cd-empty]');
    var list = root.querySelector('[data-mg-cd-items]');
    var footer = root.querySelector('[data-mg-cd-footer]');
    var upsells = root.querySelector('[data-mg-cd-upsells]');
    if (empty) {
      empty.hidden = items.length > 0;
      empty.style.display = items.length > 0 ? 'none' : '';
    }
    if (footer) footer.style.display = items.length ? '' : 'none';
    if (upsells) upsells.style.display = items.length ? '' : 'none';
    var timer = root.querySelector('[data-mg-cd-timer]');
    if (timer) timer.style.display = items.length ? '' : 'none';
    if (list) {
      var ids = mgBundleIds();
      var cmpMap = mgCompareMap();
      list.innerHTML = items.map(function (it) {
        var opt = mgVariantLabel(it);
        var meta = ids[String(it.variant_id || it.id)];
        var displayQty = meta ? meta.units * (Number(it.quantity) || 0) : it.quantity;
        var lineNow = Number(it.final_line_price != null ? it.final_line_price : it.line_price) || 0;
        var vid = String(it.variant_id || it.id);
        var cmpUnit = Number(it.compare_at_price) || Number(cmpMap[vid]) || 0;
        var lineWas = cmpUnit > 0 ? cmpUnit * (Number(it.quantity) || 0) : 0;
        var priceHtml =
          '<div class="mg-cd-item__pricing">' +
            '<div class="mg-cd-item__price">' + mgMoney(lineNow) + '</div>' +
            (lineWas > lineNow
              ? '<s class="mg-cd-item__was">' + mgMoney(lineWas) + '</s>'
              : '') +
          '</div>';
        var img = (it.image || it.featured_image || {}).url || it.image || '';
        if (typeof img === 'object' && img) img = img.url || '';
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        // Use branded projector thumb for main product line items (same as bundle cards)
        var productThumb = root.getAttribute('data-product-thumb') || '';
        var protectIdStr = String(root.getAttribute('data-protect-id') || '');
        if (productThumb && String(it.variant_id || it.id) !== protectIdStr) {
          img = productThumb;
        }
        return (
          '<li class="mg-cd-item" data-key="' + it.key + '">' +
            '<div class="mg-cd-item__media">' +
              (img ? '<img src="' + img + '" alt="" width="150" height="150" loading="lazy">' : '') +
            '</div>' +
            '<div class="mg-cd-item__right">' +
              '<div class="mg-cd-item__top">' +
                '<div>' +
                  '<h4 class="mg-cd-item__name">' + mgBrandTitle(it.product_title || it.title || '') + '</h4>' +
                  (opt ? '<p class="mg-cd-item__option">' + opt + '</p>' : '') +
                '</div>' +
                '<button type="button" class="mg-cd-item__remove" data-mg-cd-remove="' + it.key + '" aria-label="Remove">' +
                  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" aria-hidden="true"><path fill="currentColor" d="M6.5 1h3a.5.5 0 01.5.5V3h4v1H2V3h4V1.5a.5.5 0 01.5-.5zM3 5h10l-.7 9.1A1.5 1.5 0 0110.8 15.5H5.2a1.5 1.5 0 01-1.5-1.4L3 5zm2.1 1.5-.5 7h1.01l.5-7H5.1zm3.4 0v7h1v-7H8.5zm2.9 0-.5 7h1.01l.5-7H11.4z"/></svg>' +
                '</button>' +
              '</div>' +
              '<div class="mg-cd-item__bottom">' +
                '<div class="mg-cd-qty">' +
                  '<button type="button" data-mg-cd-qty="' + it.key + '" data-delta="-1" aria-label="Decrease">−</button>' +
                  '<input type="number" value="' + displayQty + '" min="0" readonly aria-label="Quantity">' +
                  '<button type="button" data-mg-cd-qty="' + it.key + '" data-delta="1" aria-label="Increase">+</button>' +
                '</div>' +
                priceHtml +
              '</div>' +
            '</div>' +
          '</li>'
        );
      }).join('');
    }

    if (!mgCartState.protectBusy) {
      mgCartPaintProtectUI(protectInCart);
    }

    var savingsEl = root.querySelector('[data-mg-cd-savings]');
    var savingsVal = root.querySelector('[data-mg-cd-savings-val]');
    var savingsCents = mgCartSavingsCents(cart, protectId);
    if (savingsEl && savingsVal) {
      if (savingsCents > 0 && items.length) {
        savingsEl.hidden = false;
        savingsEl.style.display = '';
        savingsVal.textContent = '-' + mgMoney(savingsCents);
      } else {
        savingsEl.hidden = true;
        savingsEl.style.display = 'none';
        savingsVal.textContent = '';
      }
    }
    var sub = root.querySelector('[data-mg-cd-subtotal]');
    if (sub) sub.textContent = mgMoney(cart.total_price);
  }

  /** If only Shipping Protection left — remove it so cart is truly empty. */
  function mgCartClearOrphanProtect(cart) {
    var protectId = mgProtectId();
    if (!protectId || !cart) return Promise.resolve(cart);
    var products = mgCartProductItems(cart, protectId);
    var protect = mgCartProtectLine(cart, protectId);
    if (products.length === 0 && protect) {
      mgCartState.protectOptedOut = false;
      return nativeFetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: protect.key, quantity: 0 })
      }).then(function (r) { return r.json(); }).then(function (next) {
        if (next.status) throw new Error(next.description || next.message || 'Cart update failed');
        mgCartRender(next);
        return next;
      });
    }
    return Promise.resolve(cart);
  }

  /** Ensure Shipping Protection is in cart when there are products (default ON). */
  function mgCartEnsureProtect(cart) {
    if (mgIsModeration()) return Promise.resolve(cart);
    var protectId = mgProtectId();
    if (!protectId || !cart || mgCartState.protectOptedOut) return Promise.resolve(cart);
    var hasProduct = mgCartProductItems(cart, protectId).length > 0;
    var hasProtect = !!mgCartProtectLine(cart, protectId);
    if (hasProduct && !hasProtect) {
      return mgCartToggleProtect(true, { silent: true });
    }
    return Promise.resolve(cart);
  }

  function mgCartFetch() {
    return nativeFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return mgCartNormalizeBundles(cart);
      })
      .then(function (cart) {
        mgCartRender(cart);
        return cart;
      });
  }

  /** Moderation: strip Shipping Protection if it was left in the cart. */
  function mgCartStripProtectModeration(cart) {
    if (!mgIsModeration() || !cart) return Promise.resolve(cart);
    var protectId = '59521252196700';
    var protect = (cart.items || []).find(function (it) {
      return String(it.id) === protectId || String(it.variant_id) === protectId;
    });
    if (!protect) return Promise.resolve(cart);
    return nativeFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: protect.key, quantity: 0 })
    }).then(function (r) { return r.json(); }).then(function (next) {
      if (next.status) throw new Error(next.description || next.message || 'Cart update failed');
      mgCartRender(next);
      return next;
    });
  }

  function mgCartRefreshAndOpen() {
    return mgCartFetch()
      .then(function (cart) { return mgCartClearOrphanProtect(cart); })
      .then(function (cart) { return mgCartStripProtectModeration(cart); })
      .then(function (cart) { return mgCartEnsureProtect(cart); })
      .then(function () { mgCartOpen(); });
  }

  /** Set absolute projector count and rebalance to correct bundle variant/price. */
  function mgCartSetProjectorCount(n) {
    n = Math.max(0, Number(n) || 0);
    var map = mgBundleMap();
    var ids = mgBundleIds(map);
    var cart = mgCartState.cart;
    if (!map || !cart) return Promise.resolve(cart);

    var protectId = mgProtectId();
    var bundleLines = mgCartProductItems(cart, protectId).filter(function (it) {
      return mgIsBundleLine(it, ids);
    });
    var updates = {};
    bundleLines.forEach(function (it) {
      updates[it.key] = 0;
    });

    var clearPromise = Object.keys(updates).length
      ? nativeFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (r) { return r.json(); })
      : Promise.resolve(cart);

    return clearPromise.then(function (cleared) {
      if (cleared && cleared.status) throw new Error(cleared.description || cleared.message || 'Cart update failed');
      var desired = mgDesiredBundleLine(n, map);
      if (!desired) {
        mgCartRender(cleared || cart);
        return mgCartClearOrphanProtect(cleared || cart);
      }
      return nativeFetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: desired.id, quantity: desired.qty }] })
      })
        .then(function (r) { return r.json(); })
        .then(function (added) {
          if (added.status) throw new Error(added.description || added.message || 'Cart add failed');
          return nativeFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
            return r.json();
          });
        })
        .then(function (next) {
          return mgCartNormalizeBundles(next);
        })
        .then(function (next) {
          mgCartRender(next);
          return mgCartClearOrphanProtect(next);
        })
        .then(function (next) {
          return mgCartEnsureProtect(next);
        });
    });
  }

  function mgCartChangeQty(key, qty) {
    var cart = mgCartState.cart;
    var item = cart && (cart.items || []).find(function (it) { return it.key === key; });
    var ids = mgBundleIds();
    if (item && mgIsBundleLine(item, ids)) {
      // Qty on packs is not 1:1 with projectors — rebuild from target projector count.
      var protectId = mgProtectId();
      var others = 0;
      mgCartProductItems(cart, protectId).forEach(function (it) {
        if (it.key === key) return;
        var meta = ids[String(it.variant_id || it.id)];
        if (meta) others += meta.units * (Number(it.quantity) || 0);
      });
      var meta = ids[String(item.variant_id || item.id)];
      var lineUnits = meta ? meta.units : 1;
      // Interpreting `qty` as line quantity: projectors from this line = qty * unitsPerLineItem
      // For Buy 2 pack, units=2 and qty is always 0 or 1 in normalized form.
      var target = others + lineUnits * Math.max(0, Number(qty) || 0);
      // Special case: +/- UI passes absolute line qty; for pack Buy 2, increasing line qty to 2
      // would mean 4 projectors. Prefer projector-delta API from click handler instead.
      return mgCartSetProjectorCount(target);
    }

    return nativeFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (next) {
      if (next.status) throw new Error(next.description || next.message || 'Cart update failed');
      return mgCartNormalizeBundles(next);
    }).then(function (next) {
      mgCartRender(next);
      return mgCartClearOrphanProtect(next);
    });
  }

  /**
   * Toggle Shipping Protection.
   * Optimistic UI first (instant checkbox), cart API syncs in background.
   */
  function mgCartToggleProtect(on, opts) {
    opts = opts || {};
    var id = mgProtectId();
    if (!id) return Promise.resolve();
    var cart = mgCartState.cart;
    var existing = mgCartProtectLine(cart, id);
    var root = document.querySelector('[data-mg-cd]');
    var sub = root && root.querySelector('[data-mg-cd-subtotal]');
    var protectCents = mgCartProtectCents(cart);
    var baseTotal = Number(cart && cart.total_price) || 0;
    if (existing) baseTotal -= protectCents;
    var nextTotal = on ? baseTotal + protectCents : baseTotal;

    if (!opts.silent) {
      mgCartPaintProtectUI(on);
      if (sub) sub.textContent = mgMoney(nextTotal);
    }

    if (on) {
      mgCartState.protectOptedOut = false;
      if (existing) {
        if (!opts.silent) mgCartPaintProtectUI(true);
        return Promise.resolve(cart);
      }
      mgCartState.protectBusy = true;
      return nativeFetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
        .then(function () { return mgCartFetch(); })
        .catch(function (err) {
          mgCartPaintProtectUI(false);
          if (sub && cart) sub.textContent = mgMoney(cart.total_price);
          throw err;
        })
        .finally(function () { mgCartState.protectBusy = false; });
    }

    mgCartState.protectOptedOut = true;
    if (!existing) {
      mgCartPaintProtectUI(false);
      return Promise.resolve(cart);
    }
    mgCartState.protectBusy = true;
    return nativeFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: existing.key, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (next) {
        if (next.status) throw new Error(next.description || next.message || 'Cart update failed');
        mgCartRender(next);
        return next;
      })
      .catch(function (err) {
        mgCartPaintProtectUI(true);
        if (sub && cart) sub.textContent = mgMoney(cart.total_price);
        throw err;
      })
      .finally(function () { mgCartState.protectBusy = false; });
  }

  function initMgCartDrawer() {
    var root = document.querySelector('[data-mg-cd]');
    if (!root || root.__mgInit) return;
    root.__mgInit = true;

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-mg-cd-close]')) {
        e.preventDefault();
        mgCartClose();
        return;
      }
      var rem = e.target.closest('[data-mg-cd-remove]');
      if (rem) {
        e.preventDefault();
        mgCartChangeQty(rem.getAttribute('data-mg-cd-remove'), 0);
        return;
      }
      var qtyBtn = e.target.closest('[data-mg-cd-qty]');
      if (qtyBtn) {
        e.preventDefault();
        var key = qtyBtn.getAttribute('data-mg-cd-qty');
        var delta = parseInt(qtyBtn.getAttribute('data-delta') || '0', 10);
        var item = (mgCartState.cart && mgCartState.cart.items || []).find(function (it) { return it.key === key; });
        if (!item) return;
        var ids = mgBundleIds();
        if (mgIsBundleLine(item, ids)) {
          // ±1 projector (not ±1 pack line), so 1→2 applies $59.95 tier and 2→3 applies $49.95.
          var total = mgProjectorCount(mgCartState.cart);
          mgCartSetProjectorCount(Math.max(0, total + delta));
          return;
        }
        var next = Math.max(0, (item.quantity || 0) + delta);
        mgCartChangeQty(key, next);
        return;
      }
      var up = e.target.closest('[data-mg-cd-upsell-toggle]');
      if (up) {
        e.preventDefault();
        if (mgCartState.protectBusy) return;
        var box = up.closest('[data-mg-cd-upsell]');
        var selected = box && box.getAttribute('data-selected') === 'true';
        mgCartToggleProtect(!selected);
      }
    });

    document.querySelectorAll('[data-mg-cart-open]').forEach(function (btn) {
      if (btn.__mgCartOpen) return;
      btn.__mgCartOpen = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (mgCartIsPageMode(root)) {
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        mgCartRefreshAndOpen();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open') && !mgCartIsPageMode(root)) {
        mgCartClose();
      }
    });

    mgCartFetch()
      .then(function (cart) { return mgCartClearOrphanProtect(cart); })
      .then(function () {
        if (mgCartIsPageMode(root)) mgCartOpen();
      })
      .catch(function () {
        if (mgCartIsPageMode(root)) mgCartOpen();
      });
  }

  /* ---------------------------------------------------------------------- *
   * Gallery
   * ---------------------------------------------------------------------- */
  function initGallery(g) {
    if (g.__mgInit) return;
    g.__mgInit = true;

    var track = g.querySelector('[data-mg-track]');
    var slides = Array.prototype.slice.call(g.querySelectorAll('[data-mg-slide]'));
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-mg-thumb]'));
    var prev = g.querySelector('[data-mg-prev]');
    var next = g.querySelector('[data-mg-next]');
    var counter = g.querySelector('[data-mg-counter]');
    if (!track || slides.length === 0) return;

    var current = 0;
    var raf = 0;

    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, idx) {
        var on = idx === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && t.parentNode) {
          var box = t.parentNode;
          var left = t.offsetLeft - (box.clientWidth - t.clientWidth) / 2;
          if (box.scrollTo) box.scrollTo({ left: left, behavior: 'smooth' });
        }
      });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
      if (counter) counter.textContent = i + 1 + ' / ' + slides.length;
    }

    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      setActive(i);
    }

    track.addEventListener(
      'scroll',
      function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          var w = track.clientWidth || 1;
          var i = Math.round(track.scrollLeft / w);
          if (i !== current) setActive(i);
        });
      },
      { passive: true }
    );

    thumbs.forEach(function (t, idx) {
      t.addEventListener('click', function () {
        go(idx);
      });
    });

    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
    });

    window.addEventListener('resize', function () {
      track.scrollTo({ left: current * track.clientWidth });
    });

    // Desktop: click-drag to swipe
    var down = false, startX = 0, startLeft = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) {
        moved = true;
        track.style.scrollSnapType = 'none';
        track.scrollLeft = startLeft - dx;
      }
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      if (moved) {
        track.style.scrollSnapType = '';
        go(Math.round(track.scrollLeft / (track.clientWidth || 1)));
      }
    });

    setActive(0);
  }

  /* ---------------------------------------------------------------------- *
   * Misc: reveal, sticky bar, scroll-to-buy
   * ---------------------------------------------------------------------- */
  function initPage() {
    document.querySelectorAll('.mg-lp').forEach(function (lp) {
      lp.classList.add('mg-js');
    });

    var reveals = document.querySelectorAll('.mg-reveal');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) {
              en.target.classList.add('is-in');
              io.unobserve(en.target);
            }
          });
        },
        { threshold: 0.15 }
      );
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    }

    document.querySelectorAll('[data-mg-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-mg-bundles]').forEach(initBundles);
    initMobileMenu();
    initHeaderScroll();
    initMomentsScroll();
    initMgCartDrawer();

    var bar = document.querySelector('[data-mg-sticky]');
    var submit = document.querySelector('[data-mg-atc]');
    if (bar && submit && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        bar.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0);
      }).observe(submit);
    }
  }

  /* ---------------------------------------------------------------------- *
   * Mobile hamburger menu
   * ---------------------------------------------------------------------- */
  function initMobileMenu() {
    var btn = document.querySelector('[data-mg-menu]');
    var drawer = document.querySelector('[data-mg-drawer]');
    var backdrop = document.querySelector('[data-mg-menu-backdrop]');
    if (!btn || !drawer || btn.__mgMenuInit) return;
    btn.__mgMenuInit = true;

    function setOpen(open) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        drawer.hidden = false;
        if (backdrop) backdrop.hidden = false;
        document.body.classList.add('mg-menu-open');
      } else {
        drawer.hidden = true;
        if (backdrop) backdrop.hidden = true;
        document.body.classList.remove('mg-menu-open');
      }
    }

    function toggle() {
      setOpen(btn.getAttribute('aria-expanded') !== 'true');
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggle();
    });

    if (backdrop) {
      backdrop.addEventListener('click', function () {
        setOpen(false);
      });
    }

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('a')) setOpen(false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });

    window.addEventListener('resize', function () {
      if (window.matchMedia('(min-width: 750px)').matches) setOpen(false);
    });
  }

  /* ---------------------------------------------------------------------- *
   * Moments carousel: horizontal drag only; vertical scroll stays on page
   * ---------------------------------------------------------------------- */
  function initMomentsScroll() {
    var grids = document.querySelectorAll('.mg-moments__grid');
    grids.forEach(function (grid) {
      if (grid.__mgMomentsInit) return;
      // Skip stacked (vertical) layouts — only wire horizontal carousel when scrolling
      var overflowX = window.getComputedStyle(grid).overflowX;
      if (overflowX !== 'auto' && overflowX !== 'scroll') return;
      grid.__mgMomentsInit = true;

      var dragging = false;
      var startX = 0;
      var startY = 0;
      var startScroll = 0;
      var axis = null;

      function onDown(clientX, clientY) {
        dragging = true;
        axis = null;
        startX = clientX;
        startY = clientY;
        startScroll = grid.scrollLeft;
      }

      function onMove(clientX, clientY, e) {
        if (!dragging) return;
        var dx = clientX - startX;
        var dy = clientY - startY;
        if (!axis) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        }
        if (axis === 'x') {
          grid.scrollLeft = startScroll - dx;
          if (e && e.cancelable) e.preventDefault();
        }
      }

      function onUp() {
        dragging = false;
        axis = null;
      }

      grid.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        onDown(e.clientX, e.clientY);
        try { grid.setPointerCapture(e.pointerId); } catch (err) {}
      });
      grid.addEventListener('pointermove', function (e) {
        onMove(e.clientX, e.clientY, e);
      }, { passive: false });
      grid.addEventListener('pointerup', onUp);
      grid.addEventListener('pointercancel', onUp);

      // Trackpad / mouse wheel: keep horizontal swipe on the strip
      grid.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && e.deltaX !== 0) {
          grid.scrollLeft += e.deltaX;
          e.preventDefault();
        }
        // Vertical deltaY is left alone so the page scrolls
      }, { passive: false });
    });
  }

  /* ---------------------------------------------------------------------- *
   * Mobile header:
   *  - first screen: static in document flow (no sticky/fixed jitter)
   *  - after it scrolls away: fixed + hide on scroll down / show on scroll up
   * ---------------------------------------------------------------------- */
  function initHeaderScroll() {
    var header = document.querySelector('[data-mg-header]');
    var spacer = document.querySelector('[data-mg-header-spacer]');
    var countdown = document.querySelector('.mg-countdown');
    if (!header || header.__mgScrollInit) return;
    header.__mgScrollInit = true;

    var mq = window.matchMedia('(max-width: 749px)');
    var lastY = window.scrollY || 0;
    var ticking = false;
    var pinned = false;
    var hidden = false;
    var accum = 0;
    var lockUntil = 0;
    var pinAt = 0;
    var headerH = 0;
    var HIDE_AFTER = 56;
    var SHOW_AFTER = 56;
    var LOCK_MS = 340;

    function menuOpen() {
      var btn = document.querySelector('[data-mg-menu]');
      return !!(btn && btn.getAttribute('aria-expanded') === 'true');
    }

    function measurePin() {
      if (pinned) return;
      if (countdown) {
        var cd = countdown.getBoundingClientRect();
        pinAt = Math.round(cd.bottom + (window.scrollY || 0));
      } else {
        pinAt = Math.round(header.getBoundingClientRect().top + (window.scrollY || 0));
      }
      headerH = Math.ceil(header.getBoundingClientRect().height);
    }

    function setSpacer(h) {
      if (spacer) spacer.style.height = (h || 0) + 'px';
    }

    function exitPinned() {
      if (!pinned && !header.classList.contains('is-fixed')) {
        setSpacer(0);
        return;
      }
      pinned = false;
      hidden = false;
      accum = 0;
      lockUntil = 0;
      // Drop transform instantly before leaving fixed, so the in-flow header
      // does not animate translateY and sit on top of the countdown bar.
      header.style.transition = 'none';
      header.style.transform = 'none';
      header.classList.remove('is-fixed', 'is-hidden');
      setSpacer(0);
      void header.offsetHeight;
      header.style.transition = '';
      header.style.transform = '';
    }

    function enterPinned() {
      if (pinned) return;
      measurePin();
      if (headerH < 1) headerH = 56;
      pinned = true;
      hidden = true;
      accum = 0;
      setSpacer(headerH);
      header.classList.add('is-fixed');
      header.classList.add('is-hidden');
      lockUntil = Date.now() + LOCK_MS;
    }

    function setPinnedHidden(nextHidden) {
      if (!pinned || nextHidden === hidden) return;
      if (Date.now() < lockUntil) return;
      // Never show a fixed header while the countdown band is still on screen —
      // that puts the header on top of the bar and leaves a spacer hole below.
      if (!nextHidden && shouldStayInFlow(window.scrollY || 0)) {
        exitPinned();
        return;
      }
      hidden = nextHidden;
      header.classList.toggle('is-hidden', hidden);
      accum = 0;
      lockUntil = Date.now() + LOCK_MS;
    }

    function shouldStayInFlow(y) {
      if (y < 16) return true;
      if (countdown) {
        var cbox = countdown.getBoundingClientRect();
        // Any part of the green bar still in the top of the viewport → in-flow header.
        if (cbox.bottom > 1) return true;
      }
      if (y <= pinAt) return true;
      return false;
    }

    function apply(y) {
      if (!mq.matches) {
        exitPinned();
        lastY = y;
        accum = 0;
        return;
      }

      if (menuOpen()) {
        if (pinned) {
          header.classList.remove('is-hidden');
          hidden = false;
          accum = 0;
        }
        lastY = y;
        return;
      }

      if (!pinned) measurePin();

      if (shouldStayInFlow(y)) {
        exitPinned();
        lastY = y;
        accum = 0;
        return;
      }

      if (!pinned) enterPinned();

      var diff = y - lastY;
      lastY = y;

      if (Date.now() < lockUntil) return;
      if (Math.abs(diff) < 2) return;

      if ((hidden && diff > 0) || (!hidden && diff < 0)) {
        accum = 0;
      }
      accum += diff;

      if (!hidden && accum >= HIDE_AFTER) {
        setPinnedHidden(true);
      } else if (hidden && accum <= -SHOW_AFTER) {
        setPinnedHidden(false);
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        apply(window.scrollY || 0);
        ticking = false;
      });
    }

    measurePin();
    exitPinned();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('scrollend', function () {
      apply(window.scrollY || 0);
    }, { passive: true });
    window.addEventListener('touchend', function () {
      apply(window.scrollY || 0);
    }, { passive: true });
    window.addEventListener('resize', function () {
      if (!pinned) measurePin();
      apply(window.scrollY || 0);
    });

    // Hard guarantee: when the countdown bar intersects the viewport, unpin.
    if (countdown && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (entry && entry.isIntersecting) {
          exitPinned();
          lastY = window.scrollY || 0;
          accum = 0;
        }
      }, { root: null, threshold: 0, rootMargin: '0px' });
      io.observe(countdown);
    }

    apply(window.scrollY || 0);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mg-scroll-buy]');
    if (!btn) return;
    var target = document.querySelector('[data-mg-bundles]') || document.querySelector('[data-mg-atc]');
    if (!target) {
      var href = btn.getAttribute('data-href');
      if (href) window.location.href = href;
      return;
    }
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPage);
  } else {
    initPage();
  }

  // Theme editor: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', initPage);
})();
